<template>
  <b-sidebar
    id="sidebar-jurisdiction"
    bg-variant="white"
    width="520px"
    backdrop
    shadow
    right
    v-model="jurisdictionShow"
    :no-header="true"
    @hidden="sidebarHidden"
  >
    <div
      class="d-flex align-items-center justify-content-between px-6 py-4 borderB"
    >
      <h3>{{ title }}</h3>
      <b-icon
        stacked
        icon="x"
        scale=".7"
        style="width: 35px; padding-bottom: 2px"
        @click="addSidebarShow"
        class="close"
      ></b-icon>
    </div>
    <div class="px-6 py-6">
      <slot></slot>
    </div>
    <template v-slot:footer>
      <div
        class="d-flex align-items-center justify-content-end py-4 px-6 borderT"
      >
        <b-button
          variant="primary"
          class="mr-4"
          @click="letButton"
          :form="formId"
          :type="formId ? 'submit' : ''"
          v-if="leftBtnShow"
          >{{ leftButName }}</b-button
        >
        <b-button
          variant="outline-secondary"
          @click="rightButton"
          v-if="rightBtnShow"
          >{{ rightButName }}</b-button
        >
      </div>
    </template>
  </b-sidebar>
</template>
<style lang="scss" scoped>
.close {
  cursor: pointer;
}
</style>
<script>
export default {
  props: {
    leftBtnShow: {
      type: Boolean,
      default: true,
    },
    rightBtnShow: {
      type: Boolean,
      default: true,
    },
    title: {},
    formId: {},
    rightButName: {
      type: String,
      default: "关闭",
    },
    leftButName: {
      type: String,
      default: "提交",
    },
  },
  watch: {},
  name: "LSidebar",
  created() {},
  data() {
    return {
      jurisdictionShow: false,
    };
  },
  components: {},
  methods: {
    sidebarHidden() {
      this.$emit("sidebarHidden");
    },
    letButton(o) {
      this.$emit("letButton", o);
    },
    rightButton(o) {
      this.$emit("rightButton", o);
    },
    addJurisdictionShow(o) {
      this.jurisdictionShow = o;
    },
    addSidebarShow() {
      this.addJurisdictionShow(false);
    },
  },
  mounted() {},
};
</script>
